export enum ApplicationType {
  FAST_APPLICATION = "FAST_APPLICATION",
  EXPORT_APPLICATION = "EXPORT_APPLICATION",
  FAST_APPLICATION_EMAIL = "FAST_APPLICATION_EMAIL",
  EXTERNAL = "EXTERNAL",
  NONE = "NONE",
}
